module.exports = __webpack_public_path__ + "img/cate-1-2ca21b.png";